import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { bidingService } from '../../services/BidingService';

const GENERIC_INACTIVE_BIDDING_ERROR = 'Aceasta licitatie nu este activa.';

export const useActiveBiddingGuard = (listToken, navigate) => {
    const [canLoadBiddingData, setCanLoadBiddingData] = useState(false);

    useEffect(() => {
        if (!listToken) {
            setCanLoadBiddingData(false);
            return;
        }

        let isMounted = true;
        // Reset loading gate on token change to avoid premature data calls.
        setCanLoadBiddingData(false);

        const blockBiddingDataAndRedirect = () => {
            if (!isMounted) return;

            setCanLoadBiddingData(false);
            toast.error(GENERIC_INACTIVE_BIDDING_ERROR);
            navigate('/fara-oferte', { replace: true });
        };

        bidingService.getActiveBidding()
            .then((res) => {
                if (!isMounted) return;

                const isActiveBidding = res?.data?.active === true;
                const activeBiddingToken = res?.data?.bidding?.token;

                if (!isActiveBidding) {
                    blockBiddingDataAndRedirect();
                    return;
                }

                if (activeBiddingToken && activeBiddingToken !== listToken) {
                    setCanLoadBiddingData(false);
                    toast.error(GENERIC_INACTIVE_BIDDING_ERROR);
                    navigate(`/produse-ofertare/${activeBiddingToken}`, { replace: true });
                    return;
                }

                if (!activeBiddingToken) {
                    blockBiddingDataAndRedirect();
                    return;
                }

                setCanLoadBiddingData(true);
            })
            .catch(() => {
                blockBiddingDataAndRedirect();
            });

        return () => {
            isMounted = false;
        };
    }, [listToken, navigate]);

    return { canLoadBiddingData };
};
